import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AdvantagesSection from './components/AdvantagesSection';
import CategoryNav from './components/CategoryNav';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SEOMeta from '@/components/feature/SEOMeta';
import JsonLd from '@/components/feature/JsonLd';
import { homeFAQs } from '@/mocks/home';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'qiaojzx.cn',
    url: 'https://qiaojzx.cn',
    description: '一站式综合服务平台，提供智能搜索、数据处理、即时通讯等核心在线服务。',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '浦东新区张江高科技园区博云路2号浦软大厦15层',
      addressLocality: '上海',
      addressRegion: '上海',
      postalCode: '200120',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'qiaojzx.cn 官方平台介绍与使用指南',
    url: 'https://qiaojzx.cn',
    description: 'qiaojzx.cn 一站式综合服务平台官方指南，涵盖功能介绍、使用教程、注册登录和常见问题。',
    inLanguage: 'zh-CN',
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'qiaojzx.cn 首页 - 一站式综合服务平台',
    description: 'qiaojzx.cn 官方平台首页，提供平台功能概览、核心优势展示、分类导航及精选文章推荐。',
    url: 'https://qiaojzx.cn',
    isPartOf: { '@type': 'WebSite', name: 'qiaojzx.cn', url: 'https://qiaojzx.cn' },
    inLanguage: 'zh-CN',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: homeFAQs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SEOMeta
        title="qiaojzx.cn 官方平台介绍与使用指南 | 一站式综合服务平台"
        description="qiaojzx.cn 是一站式综合服务平台，提供智能搜索、数据处理、即时通讯等核心功能。本指南详细介绍 qiaojzx.cn 的注册流程、使用教程、服务优势及常见问题，帮助用户快速上手体验安全、便捷、高效的在线服务。"
        keywords="qiaojzx.cn,qiaojzx.cn 官网入口,qiaojzx.cn 注册登录,qiaojzx.cn 使用教程,qiaojzx.cn 平台功能,qiaojzx.cn 服务优势,qiaojzx.cn 常见问题"
        canonicalUrl="https://qiaojzx.cn"
      />
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={webpageSchema} />
      <JsonLd data={faqSchema} />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AdvantagesSection />
        <CategoryNav />
        <ArticlesSection />
        <CTASection />
        <FAQSection />
      </main>
    </>
  );
}